import { useCallback, useEffect, useRef } from 'react';

/** Each load owns its signal; superseded and unmounted loads cannot commit state. */
export const useListRequest = (scope: string) => {
  const active = useRef<AbortController | null>(null);
  const currentScope = useRef(scope);
  const mounted = useRef(true);
  currentScope.current = scope;
  const cancel = useCallback(() => active.current?.abort(), []);
  const begin = useCallback(() => {
    const controller = new AbortController();
    // A save dialog can retain a refresh callback from a previous company or filter.
    if (!mounted.current || currentScope.current !== scope) {
      controller.abort();
      return controller;
    }
    active.current?.abort();
    active.current = controller;
    return controller;
  }, [scope]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      cancel();
    };
  }, [cancel]);
  return { begin, cancel };
};
